export const discountPromJsonSchema = {
  type: 'object',
  properties: {
    parentMemberId: {
      type: 'string',
      description: 'OD',
    },
    locate: {
      type: 'string',
    },
    eDOFlag: {
      type: 'string',
    },
  },
}

export const discountPromUiSchema = {
  type: 'VerticalLayout',
  className: 'identification-filters',
  elements: [
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/parentMemberId',
          component: 'ReadOnlyFieldWithJson',
          label: 'Parent Member ID',
        },
        {
          type: 'Control',
          scope: '#/properties/locate',
          component: 'ReadOnlyFieldWithJson',
          label: 'Locate',
        },
        {
          type: 'Control',
          scope: '#/properties/eDOFlag',
          component: 'ReadOnlyFieldWithJson',
          label: 'EDO Flag',
        },
      ],
    },
  ],
}
